export const VeveMotif = ({ className = "", opacity = 0.5, color = "#1F6BAD" }) => (
  <svg viewBox="0 0 400 400" fill="none" className={className} style={{ opacity }} aria-hidden="true">
    <g stroke={color} strokeWidth="1.4" strokeLinecap="round">
      {/* Poteau mitan — axe central */}
      <line x1="200" y1="30" x2="200" y2="370" />
      <line x1="40" y1="200" x2="360" y2="200" />
      {/* Volutes du carrefour */}
      <path d="M200 90 C 160 90, 150 130, 185 140 C 215 148, 230 120, 210 105" />
      <path d="M200 310 C 240 310, 250 270, 215 260 C 185 252, 170 280, 190 295" />
      <path d="M110 200 C 110 160, 70 150, 62 185 C 55 215, 85 228, 98 210" />
      <path d="M290 200 C 290 240, 330 250, 338 215 C 345 185, 315 172, 302 190" />
      {/* Cœur central orné */}
      <path d="M200 176 C 188 158, 162 164, 162 184 C 162 202, 184 212, 200 228 C 216 212, 238 202, 238 184 C 238 164, 212 158, 200 176 Z" />
      {/* Croisillons diagonaux */}
      <path d="M120 120 L 155 155 M280 120 L 245 155 M120 280 L 155 245 M280 280 L 245 245" />
      {/* Étoiles aux quatre points */}
      {[[200, 55], [200, 345], [65, 200], [335, 200]].map(([x, y], i) => (
        <g key={i}>
          <path d={`M${x - 9} ${y} L${x + 9} ${y} M${x} ${y - 9} L${x} ${y + 9} M${x - 6} ${y - 6} L${x + 6} ${y + 6} M${x - 6} ${y + 6} L${x + 6} ${y - 6}`} strokeWidth="1" />
        </g>
      ))}
      {/* Points d'offrande */}
      {[[140, 175], [260, 175], [140, 225], [260, 225], [175, 140], [225, 140], [175, 260], [225, 260]].map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r="2.2" fill={color} stroke="none" />
      ))}
      {/* Cercle d'enceinte pointillé */}
      <circle cx="200" cy="200" r="165" strokeDasharray="1 9" strokeWidth="1.6" />
    </g>
  </svg>
);
